{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Flytja til þjónustufulltrúa",
    "MESSAGE": "Tengdu mig við þjónustufulltrúa"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Sækja",
      "UPLOADING": "Hleður upp..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Senda"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Endursenda skilaboð",
      "ERROR_MESSAGE": "Tókst ekki að senda skilaboðin, reyndu aftur"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Metið gæði þessa svars"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Vinsamlegast bíddu eftir að umboðsmaður taki þátt"
  },
  "ROBOT_CHECK": {
    "TITLE": "Fljótleg öryggisathugun",
    "DESCRIPTION": "Vinsamlegast kláraðu athugunina hér fyrir neðan.",
    "VERIFYING": "Staðfestir…",
    "ERROR": "Þetta virkaði ekki. Vinsamlegast reyndu aftur.",
    "RETRY": "Reyna aftur"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Við erum tengd",
    "OFFLINE": "Það er enginn við í augnablikinu",
    "ONLINE_WITH_BOT": "Teymið og gervigreindaraðstoðarmaðurinn okkar eru við",
    "OFFLINE_WITH_BOT": "Gervigreindaraðstoðarmaðurinn okkar er hér til að hjálpa",
    "BOT_ONLY_REPLY": "Svarar samstundis"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Svarar iðulega innan nokkura mínútna",
    "IN_A_FEW_HOURS": "Svarar iðulega innan nokkura klukkustunda",
    "IN_A_DAY": "Svarar iðulega samdægurs",
    "BACK_IN": "Við verðum aftur tengd"
  },
  "DAY_NAMES": {
    "SUNDAY": "Sunnudagur",
    "MONDAY": "Mánudagur",
    "TUESDAY": "Þriðjudagur",
    "WEDNESDAY": "Miðvikudagur",
    "THURSDAY": "Fimmtudagur",
    "FRIDAY": "Föstudagur",
    "SATURDAY": "Laugardagur"
  },
  "START_CONVERSATION": "Hefja samtal",
  "END_CONVERSATION": "Ljúka samtali",
  "CONTINUE_CONVERSATION": "Halda samtali áfram",
  "YOU": "Þú",
  "START_NEW_CONVERSATION": "Hefja nýtt samtal",
  "RESOLVE_LATER": "Við leysum þetta málefni með tölvupósti/síma. Ég vil spyrja um eitthvað annað núna.",
  "VIEW_UNREAD_MESSAGES": "Þú átt ólesin skilaboð",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Sjá nýjustu skilaboð",
    "CLOSE_MESSAGES_BUTTON": "Loka",
    "COMPANY_FROM": "frá",
    "BOT": "Spjallmenni"
  },
  "BUBBLE": {
    "LABEL": "Spjallaðu við okkur"
  },
  "POWERED_BY": "Keyrt af {brandName}",
  "EMAIL_PLACEHOLDER": "Vinsamlegast sláðu inn netfangið þitt",
  "CHAT_PLACEHOLDER": "Skrifaðu skilaboðin hér",
  "TODAY": "Í dag",
  "YESTERDAY": "Í gær",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Fullt nafn",
        "PLACEHOLDER": "Vinsamlegast sláðu inn nafnið þitt",
        "REQUIRED_ERROR": "Það verður að skrifa fullt nafn"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Netfang",
        "PLACEHOLDER": "Vinsamlegast sláðu inn netfangið þitt",
        "REQUIRED_ERROR": "Það verður að skrifa netfang",
        "VALID_ERROR": "Það verður að skrifa gilt netfang"
      },
      "PHONE_NUMBER": {
        "LABEL": "Símanúmer",
        "PLACEHOLDER": "Vinsamlegast sláðu inn símanúmerið þitt",
        "REQUIRED_ERROR": "Það verður að skrifa símanúmer",
        "DIAL_CODE_VALID_ERROR": "Vinsamlegast veldu landsnúmer",
        "VALID_ERROR": "Vinsamlegast sláðu inn gilt símanúmer",
        "DROPDOWN_EMPTY": "Engar niðurstöður fundust",
        "DROPDOWN_SEARCH": "Leita að landi"
      },
      "MESSAGE": {
        "LABEL": "Skilaboð",
        "PLACEHOLDER": "Vinsamlegast sláðu inn skilaboð",
        "ERROR": "Skilaboðin eru of stutt"
      }
    },
    "CAMPAIGN_HEADER": "Vinsamlegast sláðu inn nafn og netfang áður en samtalið hefst",
    "IS_REQUIRED": "er nauðsynlegt",
    "REQUIRED": "Nauðsynlegt",
    "REGEX_ERROR": "Vinsamlegast sláðu inn gilt gildi"
  },
  "FILE_SIZE_LIMIT": "Skráin fer framyfir hámarksstærð viðhengja ({MAXIMUM_FILE_UPLOAD_SIZE})",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Ógildur reitur"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Leita að emoji",
    "NOT_FOUND": "Enginn emoji fannst",
    "ARIA_LABEL": "Emoji-val"
  },
  "CSAT": {
    "TITLE": "Gefðu samtalinu einkunn",
    "SUBMITTED_TITLE": "Takk fyrir að gefa samtalinu einkunn",
    "PLACEHOLDER": "Segðu okkur meira..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Biðja um afrit af samtalinu",
    "SEND_EMAIL_SUCCESS": "Afritið af samtalinu var sent",
    "SEND_EMAIL_ERROR": "Það kom upp villa, vinsamlegast reyndur aftur"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Vinsælar greinar",
    "VIEW_ALL_ARTICLES": "Sjá allar greinar",
    "IFRAME_LOAD_ERROR": "Villa kom upp við að hlaða greininni. Vinsamlegast endurhlaðaðu síðuna og reyndu aftur."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Opna",
      "BUY": "Kaupa"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Myndaskilaboð"
    },
    "audio": {
      "CONTENT": "Hljóðskilaboð"
    },
    "video": {
      "CONTENT": "Myndbandsskilaboð"
    },
    "file": {
      "CONTENT": "Skráarviðhengi"
    },
    "location": {
      "CONTENT": "Staðsetning"
    },
    "fallback": {
      "CONTENT": "hefur deilt vefslóð"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Svar við:"
  }
}
